import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import "./AppBarComponent.css";

/* Plain anchors so they work from any page (HomePage scrolls to the hash on load) */
const navLinks = [
  { href: "/#about", label: "About" },
  { href: "/#services", label: "Services" },
  { href: "/#work", label: "Our Work" },
  { href: "/#reviews", label: "Reviews" },
];

function AppBarComponent() {
  return (
    <React.Fragment>
      <AppBar className="AppBarComponent" position="fixed" elevation={0}>
        <Toolbar className="appbar-toolbar">
          <Link to="/" className="appbar-brand" aria-label="U.S. Auto Glass home">
            <Typography className="appbar-title" variant="h6">
              <span className="brand-accent">U.S.</span> Auto Glass{" "}
              <span className="appbar-title-small">LLC.</span>
            </Typography>
          </Link>
          <nav className="appbar-nav">
            {navLinks.map((link) => (
              <a key={link.href} href={link.href} className="appbar-link">
                {link.label}
              </a>
            ))}
          </nav>
          <Button
            className="appbar-button"
            variant="contained"
            disableElevation
            component={Link}
            to="/contact"
          >
            Request a Quote
          </Button>
        </Toolbar>
      </AppBar>
      <div className="appbar-spacer" />
    </React.Fragment>
  );
}

export default AppBarComponent;
